import type { FabricEditor } from 'modules/fabric-editor';
import { useEffect } from 'react';

const SAVE_COMBOS = ['ctrl+s', 'meta+s'];

export function useSaveHotkey(editor: FabricEditor | null, save: () => void | Promise<void>): void {
  useEffect(() => {
    if (!editor) return;

    const onKeyDown = (e: KeyboardEvent) => {
      const isSave = (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && e.key.toLowerCase() === 's';
      if (!isSave) return;
      e.preventDefault();
      void save();
    };
    window.addEventListener('keydown', onKeyDown);

    const hotkeys = editor.hotkeys;
    if (hotkeys) {
      SAVE_COMBOS.forEach((combo) => hotkeys.bind(combo, () => void save()));
    }

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      if (hotkeys) {
        SAVE_COMBOS.forEach((combo) => hotkeys.unbind(combo));
      }
    };
  }, [editor, save]);
}
